import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./Layout";
import UsersPage from "./pages/Users";
import CompaniesPage from "./pages/Companies";
import AppointmentsPage from "./pages/User Subscription";
import AdminLogin from "./pages/Login";
import ProfilePage from "./pages/Profile";
import DetailsConfirm from "./pages/Details";
import UserDetails from "./pages/User Details";
import ResultPage from "./pages/result_page";
import SubscriptionsPage from "./pages/Subscription";
import AdminDashboard from "./pages/Admin Dashboard";
import QuestionReview from "./pages/questions_check";
import VisitsDashboard from "./pages/visitors";
import AdminCreateReferral from "./pages/Referral";
import TopicsPage from "./pages/Topics";
import TeachersPage from "./pages/Teachers";
import TeacherClassesPage from "./pages/TeacherClasses";
import SchoolPerformancePage from "./pages/School Performance";
import WebinarPage from "./pages/Webinar";
import ParentWebinarPage from "./pages/ParentWebinar";

const App = () => {
  return (
    <Router>
      <Toaster position="top-center" richColors closeButton />
      <Routes>
        <Route path="/" element={<AdminLogin />} />

        <Route path="/" element={<Layout />}>
          <Route path="/dashboard" element={<AdminDashboard />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/companies" element={<CompaniesPage />} />
          <Route path="/appointments" element={<AppointmentsPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/details" element={<DetailsConfirm />} />
          <Route path="/user-details/:userId" element={<UserDetails />} />
          <Route path="/result" element={<ResultPage />} />
          <Route path="/subscription" element={<SubscriptionsPage />} />
          <Route path="/question-review" element={<QuestionReview />} />
          <Route path="/referall" element={<AdminCreateReferral />} />
          <Route path="/visitors" element={<VisitsDashboard />} />

          {/* New admin reports */}
          <Route path="/topics" element={<TopicsPage />} />
          <Route path="/teachers" element={<TeachersPage />} />
          <Route path="/teachers/:teacherId/classes" element={<TeacherClassesPage />} />
          <Route path="/school-performance" element={<SchoolPerformancePage />} />
          <Route path="/webinar" element={<WebinarPage />} />
          <Route path="/parent-webinar" element={<ParentWebinarPage />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
